export enum VmpFieldType {
  Unspecified = 0,
  Boolean = 1,
  Brush = 2,
  Character = 3,
  DateTime = 4,
  Image = 5,
  Binary = 6,
  Double = 7,
  Integer = 8,
  Text = 9,
  VirtualList = 10
}
